import { Color } from './color';
/**
 * ◇
 */
export const HollowDiamond = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'diamond' }, options), context);
};
HollowDiamond.props = Object.assign({ defaultMarker: 'hollowDiamond' }, Color.props);
//# sourceMappingURL=hollowDiamond.js.map